import Uppal from '../assets/Uppal.jpg';
import Kachiguda from '../assets/Kachiguda.jpg';
import BanjaraHillsUnit1 from '../assets/BanjaraUnit1.jpg';
import BanjaraHillsUnit2 from '../assets/BanjaraUnit2.jpg';

const locations = [
  {
    name: "Uppal Unit",
    image: Uppal,
  },
  {
    name: "Kachiguda Unit",
    image: Kachiguda,
  },
  {
    name: "Banjara Hills Unit - I",
    image: BanjaraHillsUnit1,
  },
  {
    name: "Banjara Hills Unit - II",
    image: BanjaraHillsUnit2,
  },
];

const animations = "transition-transform duration-300 hover:scale-105 hover:shadow-xl";

const LocationCard = ({ name, image }) => {
  return (
    <div
      className={`rounded-xl border border-gray-200 bg-white shadow-lg p-2 ${animations}`}
    >
      <div className="w-full h-48 overflow-hidden flex items-center justify-center rounded-lg">
        <img src={image} alt={name} className="max-w-full max-h-full object-contain" />
      </div>
      <h3 className="mt-4 text-lg font-bold text-gray-700 text-center">{name}</h3>
    </div>
  );
};

const Locations = () => {
  return (
    <div className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 text-center mb-8">
          Our Locations
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {locations.map((location, index) => (
            <LocationCard key={index} {...location} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Locations;